/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SearchRouteImport } from './routes/search'
import { Route as RequestQuoteRouteImport } from './routes/request-quote'
import { Route as QuoteResultsRouteImport } from './routes/quote-results'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LoginCallbackRouteImport } from './routes/login/callback'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const RequestQuoteRoute = RequestQuoteRouteImport.update({
  id: '/request-quote',
  path: '/request-quote',
  getParentRoute: () => rootRouteImport,
} as any)
const QuoteResultsRoute = QuoteResultsRouteImport.update({
  id: '/quote-results',
  path: '/quote-results',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginCallbackRoute = LoginCallbackRouteImport.update({
  id: '/login/callback',
  path: '/login/callback',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/contact': typeof ContactRoute
  '/logout': typeof LogoutRoute
  '/quote-results': typeof QuoteResultsRoute
  '/request-quote': typeof RequestQuoteRoute
  '/search': typeof SearchRoute
  '/terms': typeof TermsRoute
  '/login/callback': typeof LoginCallbackRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/contact': typeof ContactRoute
  '/logout': typeof LogoutRoute
  '/quote-results': typeof QuoteResultsRoute
  '/request-quote': typeof RequestQuoteRoute
  '/search': typeof SearchRoute
  '/terms': typeof TermsRoute
  '/login/callback': typeof LoginCallbackRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/contact': typeof ContactRoute
  '/logout': typeof LogoutRoute
  '/quote-results': typeof QuoteResultsRoute
  '/request-quote': typeof RequestQuoteRoute
  '/search': typeof SearchRoute
  '/terms': typeof TermsRoute
  '/login/callback': typeof LoginCallbackRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/contact'
    | '/logout'
    | '/quote-results'
    | '/request-quote'
    | '/search'
    | '/terms'
    | '/login/callback'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/contact'
    | '/logout'
    | '/quote-results'
    | '/request-quote'
    | '/search'
    | '/terms'
    | '/login/callback'
  id:
    | '__root__'
    | '/'
    | '/contact'
    | '/logout'
    | '/quote-results'
    | '/request-quote'
    | '/search'
    | '/terms'
    | '/login/callback'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ContactRoute: typeof ContactRoute
  LogoutRoute: typeof LogoutRoute
  QuoteResultsRoute: typeof QuoteResultsRoute
  RequestQuoteRoute: typeof RequestQuoteRoute
  SearchRoute: typeof SearchRoute
  TermsRoute: typeof TermsRoute
  LoginCallbackRoute: typeof LoginCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/request-quote': {
      id: '/request-quote'
      path: '/request-quote'
      fullPath: '/request-quote'
      preLoaderRoute: typeof RequestQuoteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quote-results': {
      id: '/quote-results'
      path: '/quote-results'
      fullPath: '/quote-results'
      preLoaderRoute: typeof QuoteResultsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/callback': {
      id: '/login/callback'
      path: '/login/callback'
      fullPath: '/login/callback'
      preLoaderRoute: typeof LoginCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ContactRoute: ContactRoute,
  LogoutRoute: LogoutRoute,
  QuoteResultsRoute: QuoteResultsRoute,
  RequestQuoteRoute: RequestQuoteRoute,
  SearchRoute: SearchRoute,
  TermsRoute: TermsRoute,
  LoginCallbackRoute: LoginCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
